import * as types from "./types"

// export * from "./lists"

export const initApplication = () => ({
  type: types.INIT_APPLICATION
})

// UI - Important Notifications Panel
export const setImportantNotificationsPanelOpen = isOpen => ({
  type: types.SET_IMPORTANT_NOTIFICATIONS_PANEL_OPEN,
  payload: isOpen
})
